var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgDurationIcon = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.32715 1.99292V2.99292H8.49316V3.35327C9.5865 3.45327 10.5936 3.8868 11.3936 4.55347L11.6465 4.29956L11.0596 3.71362L11.7666 3.00659L13.6533 4.89331L12.9463 5.60034L12.3604 5.01343L12.1064 5.26636C12.8731 6.19302 13.333 7.37341 13.333 8.66675H14.4531L12.8203 10.6804L11.1934 8.66675H12.3203C12.3203 6.28008 10.373 4.33374 7.98633 4.33374C5.59982 4.33392 3.65332 6.28019 3.65332 8.66675C3.65337 11.0533 5.59984 12.9996 7.98633 12.9998V13.9998C5.04651 13.9996 2.65337 11.6066 2.65332 8.66675C2.65332 7.37341 3.11322 6.19302 3.87988 5.26636L3.62695 5.01343L3.04004 5.60034L2.33301 4.89331L4.21973 3.00659L4.92676 3.71362L4.33984 4.29956L4.59375 4.55347C5.40035 3.88692 6.39997 3.45329 7.49316 3.35327V2.99292H6.66016V1.99292H9.32715ZM8.5 5.33374V9.33374H5.33301V8.33374H7.5V5.33374H8.5Z",
    fill: "#7D7D7D"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgDurationIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/Duration_Icon.5c374a78bf141629e622c312b3756676.svg";